<template>
  <div>
    <template v-if="contact.consentement">
      <div class="mb-6">
        <h3 class="headline">{{ contact.prenom }} {{ contact.nom }}{{ contact.titre ? `, ${contact.titre}` : "" }}</h3>
        <p class="mb-0">Permis délivré en {{ contact.anneeDelivrancePermis }}</p>
      </div>

      <!-- Adresses professionnelles -->
      <div class="d-flex" v-if="contact.cartesAffaires.length > 0">
        <div class="mt-3 mr-6">
          <v-icon x-large color="primary">mdi-map-marker</v-icon>
        </div>
        <div>
          <h4 class="title mb-3">Adresse(s) professionnelle(s)</h4>
          <v-expansion-panels multiple>
            <v-expansion-panel v-for="carteAffaire in contact.cartesAffaires" :key="carteAffaire.id">
              <v-expansion-panel-header class="font-weight-bold">
                {{ (carteAffaire.organisation ? carteAffaire.organisation.trim() : "") || "Bureau privé" }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-chip v-if="carteAffaire.pratiquePrivee" class="mb-2" outlined color="primary" small>Pratique privée</v-chip>
                <p class="mb-0">{{ carteAffaire.adresse }}{{ carteAffaire.complementAdresse ? `, ${carteAffaire.complementAdresse}` : "" }}</p>
                <p class="mb-0">
                  {{ carteAffaire.ville }}{{ carteAffaire.province ? ` (${carteAffaire.province})` : ""
                  }}{{ carteAffaire.estCanada ? "" : `, ${carteAffaire.pays}` }}
                </p>
                <p class="mb-0">{{ carteAffaire.codePostal }}</p>
                <p class="mb-0">{{ carteAffaire.telephone }}{{ carteAffaire.posteTelephonique ? ` poste ${carteAffaire.posteTelephonique}` : "" }}</p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>

      <!-- Secteurs de pratique -->
      <template v-if="contact.secteursDePratique.length > 0">
        <v-divider class="my-6"></v-divider>
        <div class="d-flex">
          <div class="mt-3 mr-6">
            <v-icon x-large color="primary">mdi-bullseye</v-icon>
          </div>
          <div>
            <h4 class="title">Secteur(s) de pratique</h4>
            <p class="mb-0" v-for="(secteur, i) in contact.secteursDePratique" :key="'secteur-' + i">{{ secteur }}</p>
          </div>
        </div>
      </template>

      <!-- Orientations théoriques -->
      <template v-if="contact.orientationsTheoriques.length > 0">
        <v-divider class="my-6"></v-divider>
        <div class="d-flex">
          <div class="mt-3 mr-6">
            <v-icon x-large color="primary">mdi-town-hall</v-icon>
          </div>
          <div>
            <h4 class="title">Orientation(s) théorique(s)</h4>
            <p class="mb-0" v-for="(orientation, i) in contact.orientationsTheoriques" :key="'orientation-' + i">{{ orientation }}</p>
          </div>
        </div>
      </template>

      <!-- Langues utilisées pour les services offerts -->
      <template v-if="contact.languesMaitrisees.length > 0">
        <v-divider class="my-6"></v-divider>
        <div class="d-flex">
          <div class="mt-3 mr-6">
            <v-icon x-large color="primary">mdi-translate</v-icon>
          </div>
          <div>
            <h4 class="title">Langue(s) utilisée(s) pour les services offerts</h4>
            <p class="mb-0" v-for="(langue, i) in contact.languesMaitrisees" :key="'langue-' + i">{{ langue }}</p>
          </div>
        </div>
      </template>

      <!-- Clientèle(s) -->
      <template v-if="contact.clienteles.length > 0">
        <v-divider class="my-6"></v-divider>
        <div class="d-flex">
          <div class="mt-3 mr-6">
            <v-icon x-large color="primary">mdi-account-group</v-icon>
          </div>
          <div>
            <h4 class="title">Clientèle(s)</h4>
            <p class="mb-0" v-for="(clientele, i) in contact.clienteles" :key="'clientele-' + i">{{ clientele }}</p>
          </div>
        </div>
      </template>

      <!-- Problématique(s) et service(s) offert(s) -->
      <template v-if="contact.problematiques.length > 0">
        <v-divider class="my-6"></v-divider>

        <div class="d-flex">
          <div class="mt-3 mr-6">
            <v-icon x-large color="primary">mdi-account-multiple</v-icon>
          </div>
          <div>
            <h4 class="title">Problématique(s) et service(s) offert(s)</h4>
            <div v-for="(problematiqueGroup, i) in contact.problematiques" :key="'problematiqueGroup-' + i">
              <h5 class="subtitle-1 mb-1">{{ problematiqueGroup.problematique }}</h5>
              <ul>
                <li v-for="(service, i) in problematiqueGroup.servicesOfferts" :key="'serviceOffert-' + i">{{ service }}</li>
              </ul>
              <v-divider v-if="i < contact.problematiques.length - 1" class="my-2"></v-divider>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <ressource code="informations-confidentielles"></ressource>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    contact: { type: Object },
    loading: { type: Boolean }
  },
  created() {
    this.$vuetify.goTo("#recherche-resultats")
  }
}
</script>

<style>
</style>